import React, { createContext, useEffect, useState } from "react";

const FaturamentoContext = createContext();

const FaturamentoProvider = ({ children }) => {
  const [dados, setDados] = useState([]);
  const [somaEmpresas, setSomaEmpresas] = useState({total: '', unitario: []});

  useEffect(() => {
    dados && setSomaEmpresas({unitario: handleCalculaEmpresasUnitaria(dados), total: handleCalculaEmpresasTotal(dados)})
  }, [dados])

  const formatarValor = (valor) => {
    const valorVerificado = isNaN(valor) ? 0 : valor;
    return valorVerificado.toFixed(2) 
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  const handleCalculaEmpresasUnitaria = (lista) => {
    const resultado = Object.values(
      lista.reduce((acc, curr) => {
        const vlFatura = parseFloat(curr.valorFatura?.replace("R$", "")?.replace(",", "."));
        const vlFaturaHonorario = parseFloat(curr.valorFinalHonorario?.replace("R$", "").replace(",", "."));

        if (!acc[curr.idEmpresa]) {
          acc[curr.idEmpresa] = { ...curr, valorFatura: vlFatura, valorFinalHonorario: vlFaturaHonorario};
        } else {
          acc[curr.idEmpresa].valorFatura += vlFatura;
          acc[curr.idEmpresa].valorFinalHonorario += vlFaturaHonorario;
        }
        return acc;
      }, {})
    ).map(item => ({
      cnpj: item.cnpj,
      idEmpresa: item.idEmpresa,
      razaoSocial: item.razaoSocial,
      valorFatura: `R$${formatarValor(item.valorFatura)}`,
      valorFinalHonorario: `R$${formatarValor(item.valorFinalHonorario)}`
    }));

    return resultado;
  }

  const handleCalculaEmpresasTotal = (lista) => {
    const total = lista.reduce((acc, curr) => {
      const valorNumerico = parseFloat(curr.valorFatura.replace("R$", "")?.replace(",", "."));
      return acc + valorNumerico;
    }, 0);

    return `R$${formatarValor(total)}`;
  }

  return (
    <FaturamentoContext.Provider value={{
      dados,
      setDados,
      somaEmpresas
    }}>
      {children}
    </FaturamentoContext.Provider>
  );
};

export { FaturamentoContext, FaturamentoProvider };
